import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "new-object" }
const _hoisted_2 = { class: "form-custom d-flex align-items-center w-100" }
const _hoisted_3 = { class: "p-field mr-4" }
const _hoisted_4 = {
  class: "p-field-label",
  for: "address"
}
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = {
  key: 0,
  class: "fs-13 label-error"
}
const _hoisted_7 = {
  key: 0,
  class: "p-field"
}
const _hoisted_8 = {
  class: "p-field-label",
  for: "address"
}
const _hoisted_9 = {
  key: 1,
  class: "p-field"
}
const _hoisted_10 = {
  class: "p-field-label",
  for: "address"
}
const _hoisted_11 = {
  key: 2,
  class: "p-field"
}
const _hoisted_12 = {
  class: "p-field-label",
  for: "address"
}
const _hoisted_13 = {
  key: 3,
  class: "p-field"
}
const _hoisted_14 = {
  class: "p-field-label",
  for: "address"
}
const _hoisted_15 = {
  key: 4,
  class: "p-field"
}
const _hoisted_16 = {
  class: "p-field-label",
  for: "address"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("li", _hoisted_1, [
    _createVNode("form", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('AppResource.Name')) + ":", 1),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_InputText, {
            type: "text",
            class: ["w-100", { 'input-error': _ctx.newRoomObject.isInvalid }],
            onInput: _ctx.onInputChange,
            value: _ctx.newRoomObject.name
          }, null, 8, ["onInput", "value", "class"]),
          (_ctx.newRoomObject.isInvalid)
            ? (_openBlock(), _createBlock("label", _hoisted_6, _toDisplayString(_ctx.newRoomObject.invalidReason), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.newRoomObject.type === _ctx.RoomObjectType.Shutter)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('AppResource.ManagePosition')) + ": ", 1),
            _createVNode(_component_Dropdown, {
              optionLabel: "label",
              optionValue: "value",
              options: _ctx.shutterTypes,
              modelValue: _ctx.newRoomObject.isManagePosition,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newRoomObject.isManagePosition = $event))
            }, null, 8, ["options", "modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.newRoomObject.type === _ctx.RoomObjectType.Light)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('AppResource.TypeUpper')) + ":", 1),
            _createVNode(_component_Dropdown, {
              optionLabel: "label",
              optionValue: "value",
              options: _ctx.lightTypes,
              modelValue: _ctx.newRoomObject.lightType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newRoomObject.lightType = $event))
            }, null, 8, ["options", "modelValue"])
          ]))
        : (_ctx.newRoomObject.type === _ctx.RoomObjectType.Fancoil)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('AppResource.TypeUpper')) + ":", 1),
              _createVNode(_component_Dropdown, {
                optionLabel: "label",
                optionValue: "value",
                options: _ctx.fancoilTypes,
                modelValue: _ctx.newRoomObject.thermoTypeOfObject,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newRoomObject.thermoTypeOfObject = $event))
              }, null, 8, ["options", "modelValue"])
            ]))
          : (_ctx.newRoomObject.type === _ctx.RoomObjectType.Thermostat)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('AppResource.TypeUpper')) + ":", 1),
                _createVNode(_component_Dropdown, {
                  optionLabel: "label",
                  optionValue: "value",
                  options: _ctx.thermostatTypes,
                  modelValue: _ctx.newRoomObject.thermoTypeOfObject,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.newRoomObject.thermoTypeOfObject = $event))
                }, null, 8, ["options", "modelValue"])
              ]))
            : _createCommentVNode("", true),
      (_ctx.showOtherField)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('AppResource.AssociatedPump')) + ": ", 1),
            _createVNode(_component_Dropdown, {
              optionLabel: "label",
              optionValue: "value",
              options: _ctx.thermostatAssociatedPump,
              modelValue: _ctx.newRoomObject.thermoAssociatedPump,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.newRoomObject.thermoAssociatedPump = $event))
            }, null, 8, ["options", "modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        label: _ctx.$t('AppResource.Delete'),
        class: "ml-auto p-button-text",
        onClick: _ctx.handleObjectRemove
      }, null, 8, ["label", "onClick"])
    ])
  ]))
}